<div class="card bg-base-100 shadow-xl" data-testid="email-notification-settings-card">
  <div class="card-body">
    <h2 class="card-title text-base-content">
      <app-icon name="notifications" class="mr-2"></app-icon>
      Notifications
    </h2>

    @if (loading()) {
      <div data-testid="email-notifications-loading" class="flex items-center gap-2 mt-2 text-base-content/70">
        <app-icon name="refresh" class="animate-spin"></app-icon>
        <span>Loading notification preferences...</span>
      </div>
    } @else {
      <div class="form-control mt-2">
        <label class="label cursor-pointer justify-start gap-4">
          <input
            type="checkbox"
            class="toggle toggle-primary"
            data-testid="email-notifications-toggle"
            [checked]="enabled()"
            [disabled]="saving()"
            (change)="onToggle($event)"
          />
          <span class="label-text min-w-0">
            <span class="font-medium block text-base-content">Email notifications</span>
            <span class="text-sm text-base-content/70 block">
              Get an email when learners complete units in courses where notifications are enabled.
            </span>
          </span>
        </label>
      </div>

      @if (errorMessage()) {
        <div class="alert alert-error mt-2" data-testid="email-notifications-error" role="alert">
          <app-icon name="error"></app-icon>
          <span>{{ errorMessage() }}</span>
        </div>
      }
    }
  </div>
</div>
